import { cloneDeep } from "lodash";
import ApiService from "@/core/services/api.service";
import ObjPath from "object-path";
export const SET_ENTITY = "setSelectionEntity";
export const SET_ENTITY_DATA = "setSelectionEntityData";
export const SET_ENTITY_LOADING = "setEntitySelectionLoading";
export const CLEAR_ENTITY = "clearTransactionEntity";
export const GET_ENTITY_OPTION = "getEntityOption";
export const SET_ENTITY_OPTION = "setEntityOption";
export const SET_ENTITY_DIALOG = "setDialogEntity";
/* export const GET_ENTITY_RELATED = "getEntityRelated";
export const SET_ENTITY_RELATED = "setEntityRelated"; */

// action types

export default {
  state: {
    db_entity_dialog: false,
    db_selection_entity_loading: false,
    db_selection_entity: {},
    db_entity_option: {},
  },
  getters: {
    vEntityDialog(state) {
      return state.db_entity_dialog;
    },
    vEntityLoading(state) {
      return state.db_selection_entity_loading;
    },
    reEntityId(state) {
      return state.db_selection_entity?.id;
    },
    reEntity(state) {
      return state.db_selection_entity;
    },
    vEntityOptions(state) {
      return state.db_entity_option;
    },
  },
  actions: {
    /* [GET_ENTITY_RELATED](context, payload) {
      console.log({ payload });
      return new Promise((resolve, reject) => {
        ApiService.query(`customer-related/${payload.id}`, {
          "d-type": payload.type,
        })
          .then((response) => {
            context.commit(SET_CUSTOMER_RELATED, response);
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            context.commit(SET_LOADING, false);
          });
      });
    }, */
    [CLEAR_ENTITY](context) {
      context.commit(CLEAR_ENTITY);
    },
    [SET_ENTITY_LOADING](context, payload) {
      context.commit(SET_ENTITY_LOADING, payload);
    },
  
    [SET_ENTITY_DATA](context, payload) {
      context.commit(
        SET_ENTITY,
        ObjPath.get(payload, "data.data.entity", {})
      );
    },
    [SET_ENTITY](context, payload) {
      return new Promise((resolve, reject) => {
        context.commit(SET_ENTITY, {});

        ApiService.setHeader();
        context.commit(SET_ENTITY_LOADING, true);
        ApiService.get(`entity-with-relation/${payload.id}`)
          .then((response) => {
            context.commit(
              SET_ENTITY,
              ObjPath.get(response, "data.data.entity", {})
            );
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            context.commit(SET_ENTITY_LOADING, false);
          });
      });
    },
    [GET_ENTITY_OPTION](context) {
      return new Promise((resolve, reject) => {
        context.commit(SET_ENTITY_OPTION, []);
        ApiService.setHeader();
        context.commit(SET_ENTITY_LOADING, true);
        ApiService.get(`customer/options`)
          .then((response) => {
            context.commit(SET_ENTITY_OPTION, ObjPath.get(response, "data.data", []));
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            context.commit(SET_ENTITY_LOADING, false);
          });
      });
    },
  },
  mutations: {
   /* 
    [SET_ENTITY_RELATED](state, payload) {
      state.db_ctx_related_invoices = payload?.data?.data?.invoices ?? [];
      state.db_ctx_related_quotations = payload?.data?.data?.quotations ?? [];
      state.db_ctx_related_visits = payload?.data?.data?.visits ?? [];
    }, */
    [CLEAR_ENTITY](state) {
      state.db_selection_entity_loading = false;
      state.db_selection_entity = {};
      state.db_entity_option = [];
    },
    [SET_ENTITY_LOADING](state, payload) {
      state.db_selection_entity_loading = payload;
    },

    [SET_ENTITY_DIALOG](state, payload) {
      state.db_entity_dialog = payload;
    },
    [SET_ENTITY](state, payload) {
       
      state.db_selection_entity = cloneDeep(payload);
    },
    [SET_ENTITY_OPTION](state, payload) {
      state.db_entity_option = cloneDeep(payload);
    },
  },
};
